import React from 'react'; 
import { PhotoAvatar } from '@legacy-vfuk/core-photo-avatar';
import RichTextElement from '../RichText';
import { DigitalExpertProps } from './types/DigitalExpert.types';
import {
  AvatarImageWrapper,
  DigitalExpertWrapper,
  ExpertNameWrapper,
  ExpertSummaryWrapper,
} from './styles/DigitalExpert.styles';
import getImageSrcFromGatsbyImageData from '../../../../helpers/gatsbyImageHelper';

const DigitalExpert = ({
  avatarImage,
  expertName,
  expertSummary,
}: DigitalExpertProps) => {
  return (
    <DigitalExpertWrapper>
      <AvatarImageWrapper>
        <PhotoAvatar
          image={getImageSrcFromGatsbyImageData(avatarImage.gatsbyImageData)}
          size={6}
        />
      </AvatarImageWrapper>
      <ExpertNameWrapper>{expertName}</ExpertNameWrapper>
      <ExpertSummaryWrapper>
        <RichTextElement
          key={expertSummary.id}
          rawRichText={expertSummary.text?.raw}
          color={expertSummary.color}
          textAlign={expertSummary.textAlign}
        />
      </ExpertSummaryWrapper>
    </DigitalExpertWrapper>
  );
};

export default DigitalExpert;
